<template>
    <Video 
        v-if="step.video || step.image"
        :item="{ video: step.video, image: step.image || '' }"
        v-model="playedVideo"
    />
    <img
        v-else-if="vaktaal.includes(step.title)"
        class="u-br"
        :src="vaktaalImage"
        alt="Vaktaal afbeelding"
    />
    <img
        v-else-if="checklist.includes(step.title)"
        class="u-br"
        :src="checklistImage"
        alt="Checklist afbeelding"
    />
    <h3 class="u-mt20">{{ step.title_under_video }}</h3>
    {{ step.text_under_video }}
    <FixedButton
        :isDisabled="!playedVideo" 
        @click="handleButtonClick"
    >
        {{ $t('module.toTheQuestions') }}
    </FixedButton>
</template>

<script setup>
import { ref, inject, onMounted } from 'vue';

// Components
import FixedButton from './FixedButton.vue';
import Video from './Video.vue';

const completeStep = inject('completeStep');

const vaktaal = [ 'Vaktaal', 'Vaktaalkaarten', 'jargon', 'Jargon', 'fachsprache', 'Fachsprache' ];
const checklist = [ 'Checklist', 'Oefenen', 'practice', 'Practice', 'üben', 'Üben' ];

import vaktaalImage from '@/images/vaktaal.jpg';
import checklistImage from '@/images/checklist.jpg';

const props = defineProps({
    step: Object,
});

const playedVideo = ref(false);

onMounted(() => {
    if (!props.step.video) {
        playedVideo.value = true;
    }
});

const handleButtonClick = () => {
    completeStep(props.step.uuid, true);
};
</script>